import QuickSearchResults from "./quick-search-results";
import PropTypes from "prop-types";
import React from "react";
import request from "superagent";
import "./search.scss";

class Search extends React.Component {
  constructor(props, context) {
    super(props);
    this.router = context.router;
    this.state = {
      data: {},
      totalCount: 0,
      showSearchLabel: false,
    };
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  handleLabelVisibility = (val) => {
    if (val && !this.state.showSearchLabel) {
      this.setState({ showSearchLabel: true });
    } else if (!val && this.state.showSearchLabel) {
      this.setState({ showSearchLabel: false });
    }
  };

  onSearchInputChange = (e) => {
    let val = e.target.value;
    this.handleLabelVisibility(val);

    if (val.length > 2) {
      if (this.searchRequest) {
        this.searchRequest.abort();
      }
      let query = {
        idxExclusions: this.props.idxExclusions,
        searchKey: val,
        source: !this.props.supportsMls ? "sir" : null,
        region: this.props.regionUrlParts,
      };
      this.searchRequest = request
        .post("/api/quicksearch/suggest")
        .set("Accept", "application/json")
        .send(query)
        .end(
          function (error, response) {
            if (error) {
              console.error(error);
            }
            if (response && response.body) {
              this.setState({
                data: response.body,
              });
            }
          }.bind(this)
        );
    }
  };

  componentWillUnmount() {
    if (this.searchRequest) {
      this.searchRequest.abort();
    }
  }

  submitSearch = (e) => {
    e.preventDefault();
    const region = this.props.region ? "/" + this.props.region : "";
    if (this.refs.quicksearchInput.value) {
      this.router.replace(
        region + "/quicksearch/search/" + this.refs.quicksearchInput.value
      );
    }
  };

  closeResults = () => {
    this.setState({ data: {} });
  };

  render() {
    if (!this.props.show) {
      return null;
    }
    return (
      <div id="homepage-search-interface" className="big-search">
        <div className="inner">
          <div id="homepage-search-interface" className="hero-search">
            <div id="search-cell">
              <form onSubmit={this.submitSearch}>
                {this.state.showSearchLabel && (
                  <label className="search-label" for="search">
                    Search Listings
                  </label>
                )}
                <input
                  autoComplete="off"
                  onChange={this.onSearchInputChange}
                  type="text"
                  name="search"
                  id="search"
                  ref="quicksearchInput"
                  placeholder="Search Address, Neighborhood, Zip"
                />
                <img
                  className="search-icon"
                  src="/img/search-lupe-home.png"
                  alt="search address, neighborhood, zip"
                  onClick={this.submitSearch}
                />
              </form>
            </div>
            <QuickSearchResults
              region={this.props.region}
              results={this.state.data}
              close={this.closeResults}
            />
          </div>
        </div>
      </div>
    );
  }
}

Search.defaultProps = {
  show: true,
};

Search.propTypes = {
  idxExclusions: PropTypes.array,
  region: PropTypes.string.isRequired,
  supportsMls: PropTypes.bool.isRequired,
};

export default Search;



// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/search-widget/search.js